module.exports = __webpack_public_path__ + "img/horny_mushroom_dead.3b0e79f9.png";